import React from 'react'
import './CustomArrow.scss'
export default function customPrevArrow(props) {
    if (!props.onClick) {
        return null;
    }
    return (
        <div className={props.className} onClick={props.onClick} >
            <img src={props.img} alt="left arrow" width="28px" height="28px"/>
        </div>
    )
}
